import { render, staticRenderFns } from "./adddraftactivityform.vue?vue&type=template&id=0ba766fe&scoped=true&"
import script from "./adddraftactivityform.vue?vue&type=script&lang=js&"
export * from "./adddraftactivityform.vue?vue&type=script&lang=js&"
import style0 from "./adddraftactivityform.vue?vue&type=style&index=0&id=0ba766fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba766fe",
  null
  
)

export default component.exports